import { defineMessage } from 'react-intl';
export const cancelMessage = defineMessage({
    defaultMessage: 'Cancel',
    id: 'SNyjv/',
    description: 'Cancel choosing date'
});
export const applyMessage = defineMessage({
    defaultMessage: 'Apply',
    id: 'qj3Cr1',
    description: 'Apply date'
});
export const unableParseTimeRange = defineMessage({
    defaultMessage: 'Unable to parse time range',
    id: '/Al8b0',
    description: 'Not able to parse input time range'
});
export const unableParseDateRange = defineMessage({
    defaultMessage: 'Unable to parse date range',
    id: 'nFie7Y',
    description: 'Not able to parse input date range'
});
export const timeFormatNotValid = defineMessage({
    defaultMessage: 'Time format is not valid',
    id: 'wmEEyU',
    description: 'Input don"t have proper time format'
});
export const dateFormatNotValid = defineMessage({
    defaultMessage: 'Date format is not valid',
    id: '3PRaoW',
    description: 'Input don"t have proper date format'
});
export const timeRangeNotValid = defineMessage({
    defaultMessage: 'Time range is not valid',
    id: 'ZtOziE',
    description: 'Input don"t have valid time range'
});
export const dateNotValid = defineMessage({
    defaultMessage: 'Date is not valid',
    id: 'xkXlMp',
    description: 'Input don"t have valid date'
});
export const dateRangeNotValid = defineMessage({
    defaultMessage: 'Date range is not valid',
    id: 'oyHEbU',
    description: 'Input don"t have valid date range'
});
export const dateAfterMaxAllowed = defineMessage({
    defaultMessage: 'Date is after the maximum allowed',
    id: '3BHSyB',
    description: 'Input date is after the maximum allowed date'
});
export const dateBeforeMinAllowed = defineMessage({
    defaultMessage: 'Date is before the minimum allowed',
    id: 'oBBr0n',
    description: 'Input date is before the minimum allowed date'
});
export const rangeIsNotBetweenAllowedMinMax = defineMessage({
    defaultMessage: 'Range is not between allowed minimum and maximum',
    id: 'GC7g/N',
    description: 'Input date range is not between allowed minimum and maximum date'
});
export const timeRangeInvalidFormat = defineMessage({
    defaultMessage: 'Time range format is not valid',
    id: 'l9El1F',
    description: 'Input don"t have valid time range format'
});
//# sourceMappingURL=messages.js.map